import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Image from 'next/image';
import { FC } from 'react';
import AnimatedGradientRing from '@/components/ServicesLobbyPage/BrandEvolutionSection/AnimatedGradientRing';
import { BrandNodeData } from '@/components/ServicesLobbyPage/BrandEvolutionSection/types';
import { Typography } from '@/components/shared/Typography';
import css from './style.module.scss';
interface Props {
  data: BrandNodeData;
  className?: string;
  shouldLoadVideo?: boolean;
}
const BrandNode: FC<Props> = t0 => {
  const $ = _c(23);
  const {
    data,
    className,
    shouldLoadVideo
  } = t0;
  const {
    title,
    descriptionLines,
    media
  } = data;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.root, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== media.alt || $[3] !== media.height || $[4] !== media.sources || $[5] !== media.src || $[6] !== media.type || $[7] !== media.width || $[8] !== shouldLoadVideo) {
    t2 = media.type === "image" ? <div className={css.currentMediaWrapper}><AnimatedGradientRing /><Image className={css.currentMediaImage} width={media.width} height={media.height} alt={media.alt} src={media.src} /></div> : <div className={css.newMediaWrapper}><video loop={true} playsInline={true} muted={true} preload="none" controls={false}>{shouldLoadVideo ? media.sources.map(_temp) : null}</video></div>;
    $[2] = media.alt;
    $[3] = media.height;
    $[4] = media.sources;
    $[5] = media.src;
    $[6] = media.type;
    $[7] = media.width;
    $[8] = shouldLoadVideo;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== title) {
    t3 = <Typography className={css.title} variant="h6" tag="h3">{title}</Typography>;
    $[10] = title;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== descriptionLines) {
    t4 = descriptionLines.map(_temp2);
    $[12] = descriptionLines;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <Typography className={css.description} variant="body-m" tag="div">{t4}</Typography>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className={css.content}>{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t6) {
    t7 = <div className={t1}>{t2}{t6}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default BrandNode;
function _temp(t0) {
  const {
    src,
    type
  } = t0;
  return <source key={src} src={src} type={type} />;
}
function _temp2(line) {
  return <p key={line}>{line}</p>;
}